"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/createClass.js"));
var Photo = /*#__PURE__*/function () {
  function Photo(x, y, width, height) {
    var scale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    (0, _classCallCheck2["default"])(this, Photo);
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.scale = scale;
  }
  return (0, _createClass2["default"])(Photo, [{
    key: "getWidth",
    value: function getWidth() {
      return this.width * this.scale;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.height * this.scale;
    }
  }, {
    key: "setScale",
    value: function setScale(scale) {
      this.scale = scale;
    }
  }]);
}();
var _default = exports["default"] = Photo;